// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== 배경 ===== */
.splash-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* 동영상 꽉 채우기 */
    z-index: 0;
}

/* ===== 카피 영역 ===== */
.splash-copy {
    position: absolute;
    left: 10%;
    top: 20%;
    transform: translateY(-80%);
    z-index: 1;
    pointer-events: none;
    /* 클릭 방해 X (필요 시 제거) */
}

.splash-eyebrow {
    margin: 0 0 12px 0;
    font-weight: 600;
    font-size: clamp(14px, 2.4vw, 18px);
    color: #0d0d0d;
    padding-left: 5px;
    text-shadow:
        0 0 2px #fff,
        0 0 6px rgba(255, 255, 255, 0.9),
        1px 0 0 #fff,
        -1px 0 0 #fff,
        0 1px 0 #fff,
        0 -1px 0 #fff;
}

.splash-title {
    margin: 0;
    font-weight: 800;
    line-height: 1.08;
    letter-spacing: -0.4px;
    font-size: clamp(36px, 7.2vw, 56px);
    color: #0d0d0d;
    width: 100%;
    text-shadow:
        0 0 4px #fff,
        0 0 8px rgba(255, 255, 255, 0.95),
        0 0 16px rgba(255, 255, 255, 0.7),
        1px 0 0 #fff,
        -1px 0 0 #fff,
        0 1px 0 #fff,
        0 -1px 0 #fff;
}

.splash-subtitle {
    margin: 14px 0 0 0;
    font-weight: 700;
    line-height: 1.1;
    font-size: clamp(22px, 4.8vw, 36px);
    color: #0d0d0d;
    padding-left: 2px;
    text-shadow:
        0 0 3px #fff,
        0 0 8px rgba(255, 255, 255, 0.9),
        0 0 14px rgba(255, 255, 255, 0.6),
        1px 0 0 #fff,
        -1px 0 0 #fff,
        0 1px 0 #fff,
        0 -1px 0 #fff;
}

/* ===== 하단 로고/문구 ===== */
.splash-logos {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 14px;
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/css/splash.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;IACnC,cAAc;IACd,iBAAiB;IACjB;;;;;;qBAMiB;AACrB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,mCAAmC;IACnC,cAAc;IACd,WAAW;IACX;;;;;;;qBAOiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,cAAc;IACd,iBAAiB;IACjB;;;;;;;qBAOiB;AACrB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,2BAA2B;IAC3B,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oBAAoB;AACxB","sourcesContent":["/* ===== 배경 ===== */\r\n.splash-bg {\r\n    position: absolute;\r\n    inset: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    /* 동영상 꽉 채우기 */\r\n    z-index: 0;\r\n}\r\n\r\n/* ===== 카피 영역 ===== */\r\n.splash-copy {\r\n    position: absolute;\r\n    left: 10%;\r\n    top: 20%;\r\n    transform: translateY(-80%);\r\n    z-index: 1;\r\n    pointer-events: none;\r\n    /* 클릭 방해 X (필요 시 제거) */\r\n}\r\n\r\n.splash-eyebrow {\r\n    margin: 0 0 12px 0;\r\n    font-weight: 600;\r\n    font-size: clamp(14px, 2.4vw, 18px);\r\n    color: #0d0d0d;\r\n    padding-left: 5px;\r\n    text-shadow:\r\n        0 0 2px #fff,\r\n        0 0 6px rgba(255, 255, 255, 0.9),\r\n        1px 0 0 #fff,\r\n        -1px 0 0 #fff,\r\n        0 1px 0 #fff,\r\n        0 -1px 0 #fff;\r\n}\r\n\r\n.splash-title {\r\n    margin: 0;\r\n    font-weight: 800;\r\n    line-height: 1.08;\r\n    letter-spacing: -0.4px;\r\n    font-size: clamp(36px, 7.2vw, 56px);\r\n    color: #0d0d0d;\r\n    width: 100%;\r\n    text-shadow:\r\n        0 0 4px #fff,\r\n        0 0 8px rgba(255, 255, 255, 0.95),\r\n        0 0 16px rgba(255, 255, 255, 0.7),\r\n        1px 0 0 #fff,\r\n        -1px 0 0 #fff,\r\n        0 1px 0 #fff,\r\n        0 -1px 0 #fff;\r\n}\r\n\r\n.splash-subtitle {\r\n    margin: 14px 0 0 0;\r\n    font-weight: 700;\r\n    line-height: 1.1;\r\n    font-size: clamp(22px, 4.8vw, 36px);\r\n    color: #0d0d0d;\r\n    padding-left: 2px;\r\n    text-shadow:\r\n        0 0 3px #fff,\r\n        0 0 8px rgba(255, 255, 255, 0.9),\r\n        0 0 14px rgba(255, 255, 255, 0.6),\r\n        1px 0 0 #fff,\r\n        -1px 0 0 #fff,\r\n        0 1px 0 #fff,\r\n        0 -1px 0 #fff;\r\n}\r\n\r\n/* ===== 하단 로고/문구 ===== */\r\n.splash-logos {\r\n    position: absolute;\r\n    left: 50%;\r\n    bottom: 20px;\r\n    transform: translateX(-50%);\r\n    z-index: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 14px;\r\n    pointer-events: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
